import { Skeleton } from "@/components/ui/skeleton";
import { cn } from "@/lib/utils";

export function formatMxn(n) {
  const v = typeof n === "number" ? n : Number(n || 0);
  return new Intl.NumberFormat("es-MX", {
    style: "currency",
    currency: "MXN",
    minimumFractionDigits: 2,
  }).format(v);
}

export function formatInt(n) {
  const v = typeof n === "number" ? n : Number(n || 0);
  return new Intl.NumberFormat("es-MX").format(Math.round(v));
}

export function KpiCard({
  label,
  value,
  hint,
  icon: Icon,
  testId,
  tone,
  loading = false,
  onClick,
}) {
  return (
    <div
      data-testid={testId}
      role={onClick ? "button" : undefined}
      onClick={onClick}
      className={cn(
        "bg-white border border-border rounded-lg p-5 flex flex-col gap-3 min-h-[124px]",
        onClick && "cursor-pointer hover:border-tenant transition-colors",
        tone
      )}
    >
      <div className="flex items-start justify-between">
        <div className="text-[11px] uppercase tracking-wider text-muted-foreground">
          {label}
        </div>
        {Icon && (
          <div className="h-8 w-8 rounded-md bg-slate-100 flex items-center justify-center text-slate-600">
            <Icon className="h-4 w-4" />
          </div>
        )}
      </div>
      {loading ? (
        <Skeleton className="h-8 w-24" />
      ) : (
        <div
          className="text-3xl font-semibold tracking-tight"
          style={{ fontFamily: "Chivo, sans-serif" }}
        >
          {value}
        </div>
      )}
      {hint && <div className="text-xs text-muted-foreground">{hint}</div>}
    </div>
  );
}
